import { useState, type FormEvent } from "react";
import { setInstanceCapacity, type PactureAPIInstance } from "./api";
import { useI18n } from "./i18n";
import { ManagementDialog, ManagementMessages, managementError } from "./managementUI";
import "./capacity.css";

export function CapacityDialog({ instance, csrfToken, onClose, onSuccess }: {
  instance: PactureAPIInstance; csrfToken: string; onClose: () => void; onSuccess: () => Promise<void>;
}) {
  const { t } = useI18n();
  const [slots, setSlots] = useState(instance.capacity_policy?.max_team_slots ?? instance.max_team_slots);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await setInstanceCapacity(csrfToken, reason.trim(), instance, slots);
      await onSuccess(); onClose();
    } catch (caught) { setError(managementError(caught, t)); }
    finally { setBusy(false); }
  }
  const connectionsPerTeam = Math.ceil(instance.db_connection_budget / instance.max_team_slots);
  return <ManagementDialog title={t("调整容量", "Adjust capacity")} onClose={onClose} disabled={busy}>
    <ManagementMessages error={error} />
    <p>{instance.instance_id} · {t("已加载团队", "Loaded Teams")} {instance.loaded_team_count}</p>
    <form className="monitor-form" onSubmit={submit} aria-busy={busy}>
      <label>{t("团队挂载上限", "Team slot limit")}<input type="number" required min={Math.max(1, instance.loaded_team_count)} max={1000} step={1} value={slots} disabled={busy} onChange={e => setSlots(Number(e.target.value))} aria-describedby="capacity-impact" /></label>
      <p id="capacity-impact">{t(`当前上限 ${instance.max_team_slots}；调整后连接预算约 ${slots * connectionsPerTeam}。即时调整，无需重启，不增加计算资源。`, `Current limit ${instance.max_team_slots}; projected connection budget ${slots * connectionsPerTeam}. Applied without restarting; no compute resources are added.`)}</p>
      <label>{t("操作原因", "Operation reason")}<textarea required maxLength={512} value={reason} disabled={busy} onChange={e => setReason(e.target.value)} /></label>
      <div className="dialog-actions"><button type="button" className="secondary-button" disabled={busy} onClick={onClose}>{t("取消", "Cancel")}</button><button className="primary-button" type="submit" disabled={busy || !reason.trim()}>{busy ? t("提交中…", "Submitting…") : t("确认调整", "Confirm change")}</button></div>
    </form>
  </ManagementDialog>;
}
